
import { defineComponent } from 'vue';
import StarIcon from "@/components/icons/IconStar.vue";
import EarthIcon from "@/components/icons/IconEarth.vue";
import CubeList from "@/components/CubeList.vue";

export default defineComponent({
  name: 'KeyValueSection',
  components: {
    StarIcon,
    EarthIcon,
    CubeList
  }
});
